import { useState, useEffect } from 'react';

export const useTypewriter = (text, speed = 30) => {
  const [displayedText, setDisplayedText] = useState('');
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (!text) {
      setDisplayedText('');
      setIsComplete(true);
      return;
    }

    let index = 0;
    let timeoutId;
    setDisplayedText('');
    setIsComplete(false);

    const typeNextChar = () => {
      if (index < text.length) {
        const char = text.charAt(index);
        setDisplayedText((prev) => prev + char);
        index++;
        timeoutId = setTimeout(typeNextChar, speed);
      } else {
        setIsComplete(true);
      }
    };

    // Start typing after a small delay to ensure state is ready
    timeoutId = setTimeout(typeNextChar, speed);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [text, speed]);

  return { displayedText, isComplete };
};